import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../../../components/ui/select";
import type { PhaseOption } from "../../../../hooks/useOptroTestOptions";

// Blocked options render disabled with inline reason text, not tooltips —
// disabled SelectItems are pointer-events-none and skipped in keyboard nav,
// so a tooltip would be reachable by no one.
export const OptroPhaseSelect = ({
  id,
  options,
  value,
  onChange,
}: {
  id?: string;
  options: PhaseOption[];
  value: string;
  onChange: (v: string) => void;
}) => {
  const available = options.filter((o) => o.selectable);
  const blocked = options.filter((o) => !o.selectable);

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger id={id}>
        <SelectValue placeholder="Select a test phase" />
      </SelectTrigger>
      <SelectContent>
        {available.map((o) => (
          <SelectItem key={o.optroTestId} value={String(o.optroTestId)}>
            {o.name}
          </SelectItem>
        ))}
        {blocked.length > 0 && (
          <SelectGroup>
            {/* pl-2 overrides the default pl-8 so the eyebrow sits at the menu
                edge instead of aligning with the item text. */}
            <SelectLabel className="pl-2">Unavailable</SelectLabel>
            {blocked.map((o) => (
              <SelectItem
                key={o.optroTestId}
                value={String(o.optroTestId)}
                disabled
              >
                <div className="flex flex-col items-start gap-0.5">
                  <span>{o.name}</span>
                  {o.reason && (
                    <span className="text-xs text-stone-500">{o.reason}</span>
                  )}
                </div>
              </SelectItem>
            ))}
          </SelectGroup>
        )}
      </SelectContent>
    </Select>
  );
};
